import { Controller } from "@hotwired/stimulus"

// Renders Cloudflare Turnstile on this element (see data-sitekey, data-theme, data-size, data-appearance).
export default class extends Controller {
  connect() {
    this.renderWidget()
  }

  renderWidget() {
    const sitekey = this.element.dataset.sitekey
    if (!sitekey) return

    if (!window.turnstile) {
      this.waitForTurnstile()
      return
    }

    if (this.widgetId != null) return

    this.widgetId = window.turnstile.render(this.element, {
      sitekey,
      theme: this.element.dataset.theme || "light",
      size: this.element.dataset.size || "normal",
      appearance: this.element.dataset.appearance || "always"
    })
  }

  waitForTurnstile() {
    if (this.turnstilePoll) return

    this.turnstilePoll = window.setInterval(() => {
      if (window.turnstile) {
        window.clearInterval(this.turnstilePoll)
        this.turnstilePoll = null
        this.renderWidget()
      }
    }, 100)

    window.setTimeout(() => {
      if (this.turnstilePoll) {
        window.clearInterval(this.turnstilePoll)
        this.turnstilePoll = null
      }
    }, 10000)
  }

  disconnect() {
    if (this.turnstilePoll) {
      window.clearInterval(this.turnstilePoll)
      this.turnstilePoll = null
    }

    if (this.widgetId != null && window.turnstile?.remove) {
      window.turnstile.remove(this.widgetId)
      this.widgetId = null
    }
  }
}
